module.exports = __webpack_public_path__ + "static/media/0021.81a1127e.svg";